import { renderStudio, leaveStudio, refreshStudio } from './forme-studio.js';
import { state } from './forme-app.js';
import { storeTile, addStoreTiles } from './forme-data.js';
import { hideSplash } from './forme-theme.js';

export { leaveStudio };
export function mountStudio(host, { handle, variant, token = 'studio', onReady } = {}) {
  const tile = handle ? storeTile(handle) : null;
  if (tile) { state.studioSeed = tile.id; state.studioSeedVariant = variant; }
  renderStudio(host, token, { onReady });
}
// More store tiles can arrive after the panel has opened.
export function addTiles(list) {
  addStoreTiles(list);
  refreshStudio();
}

const page = document.getElementById('app');
if (page) {
  document.body.classList.add('in-studio');
  const hash = location.hash.slice(1);
  mountStudio(page, { handle: new URLSearchParams(location.search).get('tile'), token: hash.startsWith('s_') ? hash : 'studio', onReady: hideSplash });
}
